export const userIsControlClicking = event => {
    const windowsCtrlKey = event.ctrlKey;
    const macOsCmdKey = event.metaKey;
    const mouseMiddleButton = event.button === 1;
    return windowsCtrlKey || macOsCmdKey || mouseMiddleButton;
};

// Open a url, but in a new tab if user ctrl-clicks (command on mac).
// Works like <a href="..."> with no target.
export const openHref = (
    event,
    href,
    shouldStopPropagation = true,
    shouldPreventDefault = true,
    forceOpenInNewTab = false
) => {
    if (href) {
        if (userIsControlClicking(event)) {
            openInNewTab(href);
        } else if (forceOpenInNewTab) {
            openInNewTabAndFocus(href);
        } else {
            openInThisTab(href);
        }
        // By default, stop propagation so the event doesn't bubble
        shouldStopPropagation && event.stopPropagation();
        // And prevent default so the href={...} doesn't follow since this js is going to cover that.
        shouldPreventDefault && event.preventDefault();
    }
};

// Open a url in a new tab, but focus if a user doesn't ctrl-click (command on mac).
// Works like <a href="..." target="_blank"> with no target.
export const openHrefInNewTab = (
    event,
    href,
    shouldStopPropagation = true,
    shouldPreventDefault = true
) => openHref(event, href, shouldStopPropagation, shouldPreventDefault, true);

//Utils without event handling niceties
export const openInNewTab = href => href && window.open(href, '_blank');
export const openInThisTab = href => href && window.location.assign(href);
export const openInNewTabAndFocus = href => {
    if (href) {
        const w = openInNewTab(href);
        w && w.focus();
    }
};

export default openHref;
